/* eslint-disable no-param-reassign */
import { message } from 'antd';
import axios from 'axios';
// import { logger } from 'utils/debug';

const {
  REACT_APP_REPORTEADOR_SCHEME: SCHEME,
  REACT_APP_REPORTEADOR_APIHOST: APIHOST,
  REACT_APP_REPORTEADOR_PATH: PATH,
} = process.env;

export const baseURL = `${SCHEME}://${APIHOST}${PATH}`;

const defaultOptions = {
  baseURL,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  },
};

const http = axios.create(defaultOptions);

const requestInterceptor = async (options) => {
  if (options.url[options.url.length - 1] !== '/') {
    options.url = `${options.url}/`;
  }
  return options;
};

http.interceptors.request.use(requestInterceptor);

const logger = (error) => {
  // eslint-disable-next-line no-console
  if (error?.message) {
    message.warn(error.message);
  } else if (error?.response?.data?.errors?.['$.ID'][0]) {
    message.warn(error.response.data.errors?.['$.ID'][0]);
  }
};

/**
 * POST para obtener base64 del reporteador
 * @param {Object} values
 * @returns {Promise<string>}
 */
export const postObtenerReporte = async (values) => {
  try {
    const endpoint = 'api/ConsumirReportes/ObtenerReporte_pdf';
    const { data } = await http.post('api/ConsumirReportes/ObtenerReporte_pdf', values);
    const { Error: error, MensajeError } = data;
    if (error) {
      throw new Error(MensajeError);
    }
    const base64 = `data:application/pdf;base64,${data.Documento.Base64}`;
    return base64;
  } catch (err) {
    logger(err);
    return null;
  }
};

/**
 * POST para obtener base64 del reporteador
 * @param {Object} values
 * @returns {Promise<string>}
 */
export const postObtenerDocumento = async (values) => {
  try {
    const { data } = await http.post('api/ConsumirReportes/ObtenerReporte_pdf', values);
    const { Error: hasError, MensajeError } = data;
    if (hasError) {
      logger(MensajeError);
      return [MensajeError, null];
    }
    const base64 = `data:application/pdf;base64,${data.Documento.Base64}`;
    return [null, base64];
  } catch (err) {
    logger(err);
    return ['Ha ocurrido un error al obtener el reporte'];
  }
};

export default http;
